import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsAuthorizedService } from './services/is-authorized.service';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { ProfilAcheteurComponent } from './profil-acheteur/profil-acheteur.component';

@NgModule({
  declarations: [
    ProfilAcheteurComponent
  ],
  exports: [
    ProfilAcheteurComponent
  ],
  providers: [
    IsAuthorizedService
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    MatTableModule
  ]
})
export class AdministrationModule { }
